import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';
import { AutocompleteModule } from '@lib/autocomplete';

import { Events } from '@lib/events';
import { SharedModule } from '@lib/shared';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { PosSharedModule } from './../pos-shared/pos-shared.module';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { CoreLayoutComponent } from './components/core-layout/core-layout.component';
import { FooterComponent } from './components/footer/footer.component';
import { IdleDialogComponent } from './components/idle-dialog/idle-dialog.component';
import { InfoAsideComponent } from './components/info-aside/info-aside.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LeadDetailComponent } from './components/lead-detail/lead-detail.component';
import { LoanPurposeComponent } from './components/loan-purpose/loan-purpose.component';
import { LogoutComponent } from './components/logout/logout.component';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { NavAsideComponent } from './components/nav-aside/nav-aside.component';
import { SelectLoanComponent } from './components/select-loan/select-loan.component';
import { CoreRoutingModule } from './core-routing.module';
import { AppSubmittedCheckGuard } from './guards/app-submitted-check.guard';
import { LoanSelectorGuard } from './guards/loan-selector.guard';
import { DialogService } from './services/dialog.service';
import { LoanResolverService } from './services/loan-resolver.service';
import { LookupResolverService } from './services/lookup-resolver.service';
import { PosConfigResolverService } from './services/pos-config-resolver.service';
import { UsersApiService } from './services/users-api.service';
import { AppPreloaderModule } from '../app-preloader.module';

@NgModule({
  declarations: [
    NavAsideComponent,
    InfoAsideComponent,
    LayoutComponent,
    SelectLoanComponent,
    ConfirmDialogComponent,
    MyProfileComponent,
    IdleDialogComponent,
    LoanPurposeComponent,
    CoreLayoutComponent,
    FooterComponent,
    LogoutComponent,
    LeadDetailComponent
  ],
  imports: [
    SharedModule,
    PosSharedModule,
    CoreRoutingModule,
    AutocompleteModule,
    ScrollingModule,
    NgIdleKeepaliveModule.forRoot(),
    AppPreloaderModule
  ],
  providers: [
    AppSubmittedCheckGuard,
    LoanSelectorGuard,
    Events,
    DialogService,
    LoanResolverService,
    PosConfigResolverService,
    LookupResolverService,
    UsersApiService
  ]
})
export class CoreModule {}
